import SpinModel from '../../../core/src/model/SpinModel';
import UIController from '../../../core/src/ui/UIController';
import { DefaultLayers } from '../../../core/src/utils/Layers';
import ViewManager from '../../../core/src/utils/ViewManager';
import ReelGroup from '../../../core/src/views/ReelGroup';
import { Tween } from '../../../core/src/Tween';
import App from '../../../core/src/App';
import VendorSpinResultState from '../VendorSpinResultState';
import GameModel from '../../../core/src/model/GameModel';
import { UIStates } from '../../../core/src/ui/UIStates';
import Configs from '../../vendorConfigs/Configs';


export default class VendorSpinResultMSTState extends VendorSpinResultState {
    /**
     * Values must be in ms
     */
    private _exitStateDelayOnTurboFreeSpinsMode = 1000;

    public get exitStateDelayOnTurboFreeSpinsMode() : number {
        return this._exitStateDelayOnTurboFreeSpinsMode / 1000
    }

    // Set Stop Spin Btn only when min spin time is passed
    protected setUIStateOnReelStop(): void {
        const reelGroup = <ReelGroup>ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().getSubView("ReelGroup");
        if (reelGroup.getSpinTimePassed() >= (App.config.minSpinTime * 1000)) {
            UIController.setState(UIStates.SPIN_RESULT);
        } else {
            if (Configs.reels?.clientMinSpinTime && (App.config.minSpinTime * 1000) < Configs.reels.clientMinSpinTime && !GameModel.turboSpin) {
                const delay = (App.config.minSpinTime * 1000) - reelGroup.getSpinTimePassed()
                Tween.delayedCall((delay / 1000), () => {
                    UIController.setState(UIStates.SPIN_RESULT);
                })
            }
        }
    }
    // This is client specific logic !!!
    private getStopReelsDelayTime(reelGroup: ReelGroup): number {
        let result = 0;
        if (Configs?.game?.gameType === "normal") {
            result = Math.max((Configs.reels?.clientMinSpinTime || 0), (App.config.minSpinTime * 1000)) - reelGroup.getSpinTimePassed() - reelGroup.getSpinStopTime();
            // Need to converted in seconds
            result /= 1000;
        } else {
            // Don't need to converted in seconds
            result = Math.max((Configs.reels?.clientMinSpinTime || 0), (App.config.minSpinTime * 1000)) - reelGroup.getSpinTimePassed() - reelGroup.getSpinStopTime();
        }

        if (result < 0) {
            result = 0;
        }

        return Math.floor(result)
    }

    protected getStopTime(): number {
        // Normal game stop time in ms !
        let result = App.config.stopTime * 1000;
        if (Configs?.game?.gameType === "cascade") {
            if (Configs?.reels) {
                if (GameModel.turboSpin) {
                    result = (Configs.reels.cascadeProps.mainSpinProps.stopSymbolAnimTimeInTurboMode
                        + (Configs.reels.cascadeProps.mainSpinProps.stopReelDelayInTurboMode * Configs.reels.numberOfReels)
                        + Configs.reels.cascadeProps.mainSpinProps.stopSymbolDelayInTurboMode) / 1000;
                } else {
                    result = (Configs.reels.cascadeProps.mainSpinProps.stopSymbolAnimTime
                        + (Configs.reels.cascadeProps.mainSpinProps.stopReelDelay * Configs.reels.numberOfReels)
                        + Configs.reels.cascadeProps.mainSpinProps.stopSymbolDelay) / 1000;
                }
            }
        }

        return result

    }

    protected stopReels(): void {
        if (App.config.minSpinTime < (Configs.reels?.clientMinSpinTime || 0)) {
            const reelGroup = <ReelGroup>ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().getSubView("ReelGroup");

            if (reelGroup.getSpinTimePassed() >= ((Configs?.reels?.clientMinSpinTime || (App.config.minSpinTime * 1000)) - this.getStopTime()) || GameModel.turboSpin) {
                if (GameModel.turboSpin) {
                    let delay = (App.config.minSpinTime * 1000) - reelGroup.getSpinTimePassed() - reelGroup.getSpinStopTime();
                    if (delay < 0) {
                        // Delay for security for passing min spin time  (because is possible calculation for spin pass time have correction of +- 20-40 ms )
                        delay = 100;
                    }
                    super.stopReels((delay / 1000))
                } else {
                    super.stopReels()
                }
            } else {
                super.stopReels(this.getStopReelsDelayTime(reelGroup))
            }
        } else {
            super.stopReels()
        }
    }

    public exit(): void {
        if (SpinModel.isInFreespins() && GameModel.turboSpin) {
            Tween.delayedCall(this.exitStateDelayOnTurboFreeSpinsMode, () => super.exit())
        } else {
            super.exit()
        }
    }
}
